import './ApiNotice.css';

export default function ApiNotice({ type = 'info', title, children }) {
    return (
        <div className={`api-notice api-notice-${type}`} role={type === 'error' ? 'alert' : 'status'}>
            <span className="api-notice-mark" aria-hidden="true">
                {type === 'error' ? '!' : type === 'success' ? '✓' : 'i'}
            </span>
            <div className="api-notice-content">
                {title && <strong>{title}</strong>}
                {children && <p>{children}</p>}
            </div>
        </div>
    );
}

